type BaseButtonOptions = {
  onClick: () => void;
  onPress?: () => void;
  onRelease?: () => void;
  sfx?: () => void;
};

export class BaseButton extends Phaser.GameObjects.Container {
  private activePointerId: number | null = null;
  private isPressed = false;

  protected onClick: () => void;
  protected onPress?: () => void;
  protected onRelease?: () => void;
  protected sfx?: () => void;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: BaseButtonOptions,
  ) {
    super(scene, x, y);

    this.onClick = options.onClick;
    this.onPress = options.onPress;
    this.onRelease = options.onRelease;
    this.sfx = options.sfx;
  }

  protected enableButton(width: number, height: number) {
    this.setSize(width, height);

    this.setInteractive({
      useHandCursor: true,
    });

    this.on("pointerdown", this.handlePointerDown, this);
    this.on("pointerup", this.handlePointerUp, this);
    this.on("pointerout", this.handlePointerCancel, this);
    this.on("pointerupoutside", this.handlePointerCancel, this);
  }

  private handlePointerDown(pointer: Phaser.Input.Pointer) {
    this.activePointerId = pointer.id;
    this.press(false);
  }

  private handlePointerUp(pointer: Phaser.Input.Pointer) {
    if (this.activePointerId !== pointer.id) return;

    this.activePointerId = null;
    this.release(true);
  }

  private handlePointerCancel(pointer: Phaser.Input.Pointer) {
    if (this.activePointerId !== pointer.id) return;

    this.activePointerId = null;
    this.release(false);
  }

  public press(fromKeyboard = true) {
    if (this.isPressed) return;

    this.isPressed = true;
    this.onPress?.();
    this.sfx?.();

    if (fromKeyboard) {
      this.activePointerId = null;
    }
  }

  public release(triggerClick = true) {
    if (!this.isPressed) return;

    this.isPressed = false;
    this.onRelease?.();

    if (triggerClick) {
      this.onClick();
    }
  }

  public cancel() {
    this.release(false);
  }
}
